import { render } from "./AccountOrderDetailsSummary.vue?vue&type=template&id=0df61b07"
import script from "./AccountOrderDetailsSummary.vue?vue&type=script&lang=js"
export * from "./AccountOrderDetailsSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__